"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.interceptRuntimeErrors = void 0;
/* Пример создания RuntimeErrorStore *

    // 1. Создаём store
    self.runtimeErrors = {
        _: [],
        add: function (tuple) {
            this._.push(tuple);
        },
    };

    // 2. Теперь репортер
    function (e, r) { runtimeErrors.add([e, r]) }

*/
/** Привязать JS-Ошибки во время подготовки и работы приложения к логгеру */
function interceptRuntimeErrors(logger) {
    if (typeof runtimeErrors === 'object') {
        var addError = function (_a) {
            var _b = __read(_a, 2), err = _b[0], rule = _b[1];
            if (rule.log !== false) {
                logger.error("[JS] ".concat(err.message), { error: err });
            }
        };
        runtimeErrors.add = addError;
        runtimeErrors._.forEach(addError);
        runtimeErrors._.length = 0;
    }
}
exports.interceptRuntimeErrors = interceptRuntimeErrors;
//# sourceMappingURL=runtime.js.map